import React from 'react';

import Loading, {LoadingHolder, Types} from '@pb/kit-component-loading';
import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from '../button.component.module.styl';

import type {ReactNode} from 'react';


const classNames = withCssModule(styles);

interface ButtonIconProps {
    right?: boolean,
    busy?: boolean,
    children?: ReactNode,
    /**
     * @deprecated It will be removed in 6 months 03-03-2026. Use default appearance
     */
    darkMode?: boolean,
    iconClassName?: string,
}

export function FlatButtonIcon({
    right,
    busy,
    darkMode,
    children,
    iconClassName,
}: ButtonIconProps) {

    const iconClasses = classNames('button__icon', {
        button__icon_right: right,
        button__icon_flat: true,
    }, iconClassName);

    const showLoader = busy && !right;
    const isShowIconButton = children || showLoader;

    const childrenClasses = classNames({
        button__icon_busy: showLoader,
    });

    return isShowIconButton ? (
        <span className={iconClasses}>
            {children && childrenClasses ? (
                <span className={childrenClasses}>{children}</span>
            ) : children}
            {showLoader ? (
                <LoadingHolder>
                    <Loading type={Types.ICON} darkMode={darkMode} aria-hidden="true"/>
                </LoadingHolder>
            ) : null}
        </span>
    ) : null;
}
